export default {
  login_mfa: {
    title: '@:login.title',
    message: 'Un SMS contenant un code de \nvérification a été envoyé à votre \nnuméro de téléphone enregistré',
    button_submit: '@:login.login',
    button_resend: 'Renvoyer le code de vérification',
    alert_success: 'Le code de vérification a été renvoyé',
    alert_error: "L'envoi du code de vérification a échoué",
    error: '@:common.error.code_9999',
    no_phone_number_message: "L'authentification par SMS n'a pas pu être utilisée, car le numéro de téléphone de l'utilisateur n'est pas enregistré.\n\nContactez l'administrateur de votre entreprise pour ajouter votre numéro de téléphone.",
  },
}
